/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// import * as Sentry from "@sentry/react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import DropDownSelect from "../../../../components/DropDownSelect/DropDownSelect";
import { SERVICES } from "../../../../components/Layout/Services";
import { SERVICES as MasterDataServices } from "../../../../components/Layout/Services/MasterDataServices";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
function AdvancedSearch({
  // updatePayableCity,
  // updatePaymentMethod,
  // updatePaymentGateway,
  // updateUinType,
  // updateReceiptType,
  clearValues,
  onAmountChange,
  onDataEnterdBy,
  setAdvancedSearchValues,
  amountValue,
  updateSortingMethod,
}) {
  const [payableCity, setPayableCity] = useState([]);
  // const [selectedPayableCity, setSelectedPayableCity] = useState("");
  const [selectedPayableCity, setSelectedPayableCity] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  // const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState([]);
  const [paymentGateway, setPaymentGateway] = useState([]);
  // const [selectedPaymentGateway, setSelectedPaymentGateway] = useState("");
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState([]);
  const [receiptType, setReceiptType] = useState([]);
  // const [selectedReceiptType, setSelectedReceiptType] = useState("");
  const [selectedReceiptType, setSelectedReceiptType] = useState([]);
  const [uinType, setUinType] = useState([]);
  // const [selectedUinType, setSelectedUinType] = useState("");
  const [selectedUinType, setSelectedUinType] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [newSelectedData, setNewSelectedData] = useState("");
  const [profileData, setProfileData] = useState({});
  //   const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const sortFields = [
    { value: "fullName", label: "Name" },
    { value: "orderId", label: "Order ID" },
    { value: "updatedAt", label: "Contribution Date" },
  ];

  const sortOrders = [
    { value: "ASC", label: "Ascending" },
    { value: "DESC", label: "Descending" },
  ];

  const [selectedSortField, setSelectedSortField] = useState("");
  const [selectedSortOrder, setSelectedSortOrder] = useState("");

  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
      // if (response.status === 403) {
      //   dispatch(logoutAction());
      // } else {
      //   console.error("Failed to fetch Division Type data");
      // }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePaymentMethod = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYMENT_METHODS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 73", data);
        const paymentMethodVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        // setPaymentMethods(data.data);
        setPaymentMethods(paymentMethodVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePayableCity = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYABLE_CITIES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        const payableFormattedPos = data.data.map((d) => ({
          entityTitle: d.cityName,
          value: d.cityName,
        }));
        // setPayableCity(data.data.content);
        setPayableCity(payableFormattedPos);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePaymentGateway = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYMENT_GATEWAYS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 98", data);
        const paymentGatewayVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        // setPaymentGateway(data.data);
        setPaymentGateway(paymentGatewayVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleReceiptType = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 140", data.receiptTypes);
        const receiptTypesVal = data.data.receiptTypes.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        // setReceiptType(data.data.receiptTypes);
        setReceiptType(receiptTypesVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleUinType = async () => {
    try {
      const url = `${MasterDataServices.GET_UIN_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 67", data);
        const uinTypeVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        // setUinType(data.data);
        setUinType(uinTypeVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleDataEnterBy = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER}/adminSearch?page=0&size=100&roleIds=22&roleIds=23`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 144", data);
        // const uinTypeVal = data.data.map((d) => ({
        //   entityTitle: d.name,
        //   value: d.name,
        // }));
        // setUinType(data.data);
        // setUinType(uinTypeVal);
        setSelectedData(data?.data?.content);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  // console.log(selectedPayableCity);
  useEffect(
    () => {
      handlePaymentMethod();
      handlePayableCity();
      handlePaymentGateway();
      handleReceiptType();
      handleUinType();
      handleDataEnterBy();
      // setAdvancedSearchValues((prevValues) => ({
      //   ...prevValues,
      //   selectedPayableCity,
      //   selectedPaymentMethod,
      //   selectedPaymentGateway,
      //   selectedReceiptType,
      //   selectedUinType,
      // }));
      // updatePayableCity(selectedPayableCity);
      // updatePaymentMethod(selectedPaymentMethod);
      // updatePaymentGateway(selectedPaymentGateway);
      // updateUinType(selectedUinType);
      // updateReceiptType(selectedReceiptType);
    },
    [
      // selectedPayableCity,
      // selectedPaymentMethod,
      // selectedPaymentGateway,
      // selectedUinType,
      // selectedReceiptType,
    ],
  );
  useEffect(() => {
    setAdvancedSearchValues((prevValues) => ({
      ...prevValues,
      selectedPayableCity,
      selectedPaymentMethod:
        // selectedPaymentMethod.length === 0
        //   ? ["CASH", "CHEQUE", "DEMAND_DRAFT"]
        //   : selectedPaymentMethod,
        profileData?.assignedRoles?.includes("contributionOfflineDataEntry") &&
        selectedPaymentMethod.length === 0
          ? ["CASH", "CHEQUE", "DEMAND_DRAFT"]
          : selectedPaymentMethod,
      selectedPaymentGateway,
      selectedReceiptType,
      selectedUinType,
      newSelectedData,
    }));
  }, [
    selectedPayableCity,
    selectedPaymentMethod,
    selectedPaymentGateway,
    selectedUinType,
    selectedReceiptType,
    newSelectedData,
    profileData,
  ]);
  useEffect(() => {
    getUserRole();
  }, []);
  useEffect(() => {
    if (clearValues) {
      // setInitialAdvanceFormValue(initialFormValue);
      setSelectedPaymentGateway([]);
      setSelectedPaymentMethod([]);
      setSelectedUinType([]);
      setSelectedReceiptType([]);
    }
  }, [clearValues]);

  useEffect(() => {
    const sortOrder = selectedSortOrder || "ASC";
    updateSortingMethod(`${selectedSortField},${sortOrder}`);
  }, [selectedSortField, selectedSortOrder]);

  useEffect(() => {
    if (queryParams.get("paymentGatewayTypes") === null) {
      setSelectedPaymentGateway([]);
    }
    if (queryParams.get("paymentMethodTypes") === null) {
      setSelectedPaymentMethod([]);
    }
    if (queryParams.get("uinTypes") === null) {
      setSelectedUinType([]);
    }
    if (queryParams.get("receiptType") === null) {
      setSelectedReceiptType([]);
    }
  }, [
    queryParams.get("paymentGatewayTypes"),
    queryParams.get("paymentMethodTypes"),
    queryParams.get("uinTypes"),
    queryParams.get("receiptType"),
  ]);
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={4} columnSpacing={5}>
        <Grid item xs={6}>
          <DropDownSelect
            title="Payment Method"
            multiple
            selectOptions={paymentMethods}
            value={selectedPaymentMethod}
            setValue={setSelectedPaymentMethod}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
export default AdvancedSearch;

// If we want to use AutoComplete Dropdown use commented Code otherwise use the above code
